import Axios from 'axios';

export const sendArrivedSMS = (orderId: string, to: string, msg: string) =>
  Axios.post(`${window.API_ENDPOINT}/sms/send/arrived`, { orderId, to, msg });

export const sendSingleSMS = (to: string, msg: string) =>
  Axios.post(`${window.API_ENDPOINT}/sms/send`, { to, msg });

export const sendDonationSMS = (orderId: string, to: string, msg: string) =>
  Axios.post(`${window.API_ENDPOINT}/sms/send/donation`, { orderId, to, msg });
